export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
>
  <path
    d="M 9.0163139,0.01351944 12.229272,3.2427614 6.4883699,8.9999844 12.229272,14.757208 9.0163139,17.986468 0.01352691,8.9836814 Z"
  />
</svg>`;
